module.exports = __webpack_public_path__ + "d5bc594d5f3665456035004e0530059c.png";